module.exports = __webpack_public_path__ + "static/jorge_calle_110-abc47d4f1251b8828dec6b0edfa223b8.png";